export const DONE = 'DONE';
export const ACTIVE = 'ACTIVE';
export const DISABLED = 'DISABLED';
